<template>
    <CredentialsCard
        :title="$t('auth.pwa.titles.login_form')"
        :cta-text="$t('auth.pwa.ctas.login')"
        :icon="icon"
        :processing="loginForm.processing"
        :cta-disabled="!loginForm.email || !loginForm.password"
        @confirm="handleSubmit"
    >
        <form>
            <div class="flex flex-col gap-4">
                <div class="flex flex-col gap-2">
                    <span class="font-semibold">{{
                        $t("auth.pwa.labels.email")
                    }}</span>
                    <TextField
                        v-model="loginForm.email"
                        name="email"
                        auto-complete="email"
                        input-mode="email"
                        required
                        :placeholder="$t('form.email.placeholder')"
                        :error="translateMaybe(loginForm.errors.email)"
                        :input-class="['h-14']"
                    />
                </div>
                <div class="flex flex-col gap-2">
                    <span class="font-semibold">{{
                        $t("auth.pwa.labels.password")
                    }}</span>
                    <TextField
                        v-model="loginForm.password"
                        type="password"
                        name="password"
                        auto-complete="current-password"
                        required
                        :placeholder="$t('form.password.placeholder')"
                        :error="translateMaybe(loginForm.errors.password)"
                        :input-class="['h-14']"
                    />
                </div>
            </div>
        </form>
    </CredentialsCard>
</template>

<script setup>
import CredentialsCard from "@/Components/Cards/Auth/PWA/CredentialsCard.vue";
import TextField from "@/Components/FormFields/TextField.vue";
import KeyInSquareIcon from "@/Components/Icons/KeyInSquareIcon.vue";
import { translateMaybe } from "@/Helpers/translateMaybe.js";
import { useForm } from "@inertiajs/vue3";
import { computed, markRaw } from "vue";

const loginForm = useForm({
    email: "",
    password: "",
});
const icon = computed(() => markRaw(KeyInSquareIcon));

const handleSubmit = () => {
    loginForm.post(route("login"));
};
</script>
